(() => {
  angular
    .module('app.report')
    .controller('DeliveryReportController', DeliveryReport);

  DeliveryReport.$inject = [
    '$q',
    '$scope',
    '$filter',
    '$timeout',
    '$interval',
    'Report',
    'DeliveryChartService',
    'CountriesService'
  ];

    function DeliveryReport(
      $q,
      $scope,
      $filter,
      $timeout,
      $interval,
      Report,
      DeliveryChartService,
      CountriesService
  ) {
    document.removeEventListener('visibilitychange', updateDataOnVisible);

    const KEY_TOP_PERFORMANCE_PERIOD = 'tqTopPerformancePeriod';
    const KEY_TOP_PERFORMANCE_DATE = 'tqTopPerformanceDate';
    const KEY_SELECTED_TRACKPOINT = 'tqSelectedTrackpoint';

    const {report} = $scope.$parent;
    const cache = {};
    const vm = this;
    vm.cachebusterDateLabels = {};
    vm.isOldCampaign = new Date(report.campaign.startDate) < new Date('09-24-2018');

    let isVisibilityWatcherSetted = false;
    let activeTps = [];

    activate();

    function activate() {
      report.isCampaignLoading = true;
      report.subActivate = activate;

      report.countryPromise = report.countryPromise || CountriesService.getSupported();

      $q.all([
        report.campaignPromise,
        report.countryPromise,
        report.trackpointsPromise,
      ]).then((response) => {
        cache.campaign = response[0];
        cache.country = response[1].data;

        activeTps = _.filter(response[2].data, trackpoint => trackpoint.active);
        vm.trackpointSelector.activeTps = activeTps;
      }).then(() => {
        report.isCampaignLoading = false;
        report.isCampaignLoaded = true;

        if (document.visibilityState === 'visible') {
          updateDataOnVisible();
        } else {
          if (!isVisibilityWatcherSetted) {
            document.addEventListener('visibilitychange', updateDataOnVisible);
            isVisibilityWatcherSetted = true;
          }
        }
      });
    }

    function updateDataOnVisible() {
      if (document.visibilityState !== 'visible') {
        return false;
      }

      vm.campaign = cache.campaign;

      const targetCountry = cache.country && _.find(cache.country,
        countryInfo => countryInfo.isoCode === vm.campaign.panel_country);

      vm.timezoneOffset = targetCountry && targetCountry.timezoneOffset;
      vm.noRefererImpsRatioBenchmark = targetCountry && targetCountry.noReferrerImpsRatio;

      const startDate = new Date(vm.campaign.c_start || undefined);
      const endDate = new Date(vm.campaign.c_end || undefined);
      const selectedDate = JSON.parse(localStorage.getItem(KEY_TOP_PERFORMANCE_DATE));
      vm.slider.init(startDate, endDate, selectedDate);

      const selectedTp = JSON.parse(localStorage.getItem(KEY_SELECTED_TRACKPOINT));
      const matchedTp = activeTps.find(item => selectedTp && item.name === selectedTp.name);
      if (matchedTp) {
        vm.trackpointSelector.selectedTrackpoint = selectedTp;
        vm.setChartDataScope(selectedTp.id);
      } else {
        vm.setChartDataScope('campaign');
      }
      DeliveryChartService.setupCharts(vm);

      updateTables();
    }

    function updateTables() {
      // invalidate table after splash animation finished
      $timeout(() => {
        var dtTableCountries = $('#tableTQTopCountries').DataTable();
        dtTableCountries.cells().invalidate('dom').draw();

        var dtTableIPs = $('#tableTQTopIPs').DataTable();
        dtTableIPs.cells().invalidate('dom').draw();
      }, TIME.DATA_SPLASH);
    }

    /* ------------------------------
     Hidden referrer impressions data
     --------------------------------*/
    vm.hiddenReferrerImps = {
      data: undefined,
      refreshData: function (dataSource) {
        if (angular.isUndefined(dataSource)) return;
        this.data = dataSource.unknownReferrerCount / dataSource.totalCount * 100;
      }
    };

    /* ------------------------------
     Top table and associated logic
     --------------------------------*/
    vm.top = {
      countries: undefined,
      totalCount: undefined,
      ips: undefined,
      refreshData: function (dataSource) {
        if (angular.isUndefined(dataSource)) return;
        this.countries = dataSource.lookupCountries;
        this.ips = dataSource.ips;
        this.totalCount = dataSource.totalCount;
      }
    };

    /* ------------------------------
     Trackpoint select dropdown and associated logic
     --------------------------------*/
    vm.setChartDataScope = function (chartDataScope) {
      vm.deliveryLoaded = false;
      vm.chartDataScope = chartDataScope;

      getMetricsPromise(chartDataScope)
        .then(({ data }) => {
          if (data.ex) {
            console.error(data);
            return;
          }

          vm.delivery = data;

          if (chartDataScope === 'campaign') {
            updateCampaignCharts();
          } else {
            const period = localStorage.getItem(KEY_TOP_PERFORMANCE_PERIOD);
            vm.setTrackpointDataScope(period || 'total', true);
          }

          vm.deliveryLoaded = true;
        });
    };

    vm.setTrackpointDataScope = function (scope, skipSave) {
      vm.trackpointDataScope = scope;
      if (!skipSave) {
        localStorage.setItem(KEY_TOP_PERFORMANCE_PERIOD, scope);
      }

      if (scope === 'total') {
        updateTotalCharts();
      } else {
        updateTotalCharts(true);
        updateDailyCharts();
      }
  };

    function getMetricsPromise(chartDataScope) {
      const param = {'id': vm.campaign.pid};

      if (chartDataScope === 'campaign') {
        vm.trackpointDataScope = undefined;
        report.deliveryPromise = report.deliveryPromise || Report.getDelivery(param).$promise;
        return report.deliveryPromise;
      }

      const currentTrackpoint = vm.trackpointSelector.activeTps[chartDataScope];
      param['trackpointId'] = `${currentTrackpoint.cid}:${currentTrackpoint.tailcode}`;
      return Report.getDelivery(param).$promise;
    }

    function updateCampaignCharts() {
      if (vm.delivery) {
        vm.dailyImpressions = vm.delivery.events.dailyImpressions;
        vm.hourlyImpressionsChartConfig.refreshData(vm.delivery.events.hourlyEvents);

        vm.deviceTypes = vm.delivery.devices;
        vm.hasDeviceSubcategories = vm.deviceTypes &&
          _.values(vm.deviceTypes.subdeviceCounts)
            .reduce((memo, category) => memo + _.values(category)
              .reduce((mem, value) => mem + value, 0), 0) > 0;

        vm.hiddenReferrerImps.refreshData(vm.delivery.performers);
        vm.impressionsDistributionChartConfig.refreshData(vm.delivery.performers.referrers);

        vm.top.refreshData(vm.delivery.performers);
      }
    }

    function updateTotalCharts(skipPart) {
      if (vm.delivery) {
        vm.deviceTypes = vm.delivery.devices;
        vm.dailyImpressions = vm.delivery.events.dailyImpressions;
        vm.cachebusterRatioChartConfig.refreshData(vm.delivery.cachebuster.dates);
        vm.hourlyImpressionsChartConfig.refreshData(vm.delivery.events.hourlyEvents);

        if (!skipPart) {
          vm.top.refreshData(vm.delivery.performers.totals);
          vm.hiddenReferrerImps.refreshData(vm.delivery.performers.totals);
          vm.impressionsDistributionChartConfig.refreshData(vm.delivery.performers.totals.referrers);
        }
      }
    }

    function updateDailyCharts() {
      var data = getDataForDate(vm.slider.getCurrentDate());
      vm.top.refreshData(data);
      vm.hiddenReferrerImps.refreshData(data);
      vm.impressionsDistributionChartConfig.refreshData(data.referrers);
    }

    function getDataForDate(date) {
      var data = {};
      if (vm.delivery && vm.delivery.performers.dates && vm.trackpointSelector.selectedTrackpoint.id >= 0) {
        angular.forEach(vm.delivery.performers.dates, function (dateEntry) {
          if (dateEntry.date === $filter('date')(date, "yyyy-MM-dd")) {
            data = dateEntry;
          }
        });
      }
      return data;
    }

    vm.trackpointSelector = {
      activeTps: [],
      selectedTrackpoint: {
        id: -1,
        name: ''
      },
      selectTrackpoint: function (id, point) {
        $('#deviceTypeRatio').highcharts().drillUp();

        vm.setChartDataScope(id);
        const tp = {
          id,
          name: point && point.name,
        };
        localStorage.setItem(KEY_SELECTED_TRACKPOINT, JSON.stringify(tp));
        this.selectedTrackpoint = tp
      }
    };

    // TODO: would be better off in a directive ?
    vm.slider = {
      min: 0,
      currentValue: 0,
      disabled: true,
      startDate: undefined,
      endDate: undefined,
      datesArray: [],

      getCurrentDate: function () {
        return this.datesArray[this.currentValue];
      },

      dayCount: function () {
        const count = Math.floor((this.endDate.getTime() - this.startDate.getTime()) / (24 * 60 * 60 * 1000));
        if (count) {
          this.disabled = false;
          return count;
        } else {
          this.disabled = true;
          return 0;
        }
      },

      init: function (startDate, endDate, selectedDate) {
        this.startDate = startDate;
        this.endDate = endDate;
        let currentDate = this.startDate;
        let lastDate = new Date(this.endDate);
        lastDate.setDate(lastDate.getDate() + 1);
        while (currentDate <= lastDate) {
          this.datesArray.push(new Date(currentDate));
          let newDate = new Date(currentDate);
          currentDate = newDate.setDate(newDate.getDate() + 1);
        }

        if (selectedDate) {
          let found = false;
          this.datesArray.forEach((date, index) => {
            if (new Date(date).getTime() === new Date(selectedDate).getTime() && !found) {
              this.currentValue = index;
              found = true;
            }
          });
        }
      }
    };

    /* ------------------------------
     Slider Watches
     --------------------------------*/
    let sliderStepCounter = 0; // fast update of DataTables issue
    let sliderDelay = null;
    $scope.$watch(() => vm.slider.currentValue,
      (newValue, oldValue) => {
        if (sliderStepCounter++ > 10) {
          sliderStepCounter = 10;
        }
        if (!sliderDelay && newValue && (parseInt(newValue) !== parseInt(oldValue))) {
          sliderDelay = $interval(() => {
              if (sliderStepCounter-- < 0) {
                $interval.cancel(sliderDelay);
                sliderStepCounter = 0;
                sliderDelay = null;

                updateDailyCharts();
                localStorage.setItem(KEY_TOP_PERFORMANCE_DATE,
                  JSON.stringify(vm.slider.datesArray[vm.slider.currentValue]));
              }
          }, 100);
        }
      }, true);

  }
})();
